import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInAppCheckCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "coolicons:circle-check-fill",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M1.83262 11.0001C1.83262 5.93734 5.93653 1.83342 10.9993 1.83342C16.062 1.83342 20.166 5.93734 20.166 11.0001C20.166 16.0628 16.062 20.1668 10.9993 20.1668C5.93653 20.1668 1.83262 16.0628 1.83262 11.0001ZM10.0212 12.3925L7.9807 10.352C7.80882 10.1801 7.5757 10.0836 7.33262 10.0836C7.08954 10.0836 6.85642 10.1801 6.68453 10.352C6.51265 10.5239 6.41609 10.757 6.41609 11.0001C6.41609 11.1205 6.4398 11.2396 6.48586 11.3508C6.53192 11.462 6.59943 11.5631 6.68453 11.6482L9.43453 14.3982C9.5246 14.4882 9.63244 14.5584 9.75116 14.6045C9.86989 14.6505 9.99691 14.6713 10.1241 14.6655C10.2513 14.6597 10.3759 14.6275 10.49 14.5709C10.6041 14.5143 10.7051 14.4346 10.7866 14.3368L15.37 8.83676C15.4504 8.74476 15.5117 8.6376 15.5502 8.52158C15.5886 8.40555 15.6035 8.28301 15.5939 8.16116C15.5843 8.03931 15.5504 7.92061 15.4942 7.81204C15.4381 7.70347 15.3608 7.60724 15.2669 7.52899C15.173 7.45074 15.0644 7.39206 14.9475 7.3564C14.8305 7.32074 14.7077 7.30882 14.5861 7.32135C14.4645 7.33387 14.3467 7.37059 14.2395 7.42934C14.1323 7.48808 14.0379 7.56767 13.962 7.66342L10.0212 12.3925Z",
			fill: "#45CB01"
		})
	})
});
export default SvgInAppCheckCircle;
